import { Expose } from 'class-transformer'
import { Quote } from '../../entity'

export class GetScheduledQuotesDTO {

    @Expose()
    quotes!: Quote[]

}
